import * as moment from 'moment';
import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { FoodPlanModel, UserModel } from '../../models/models';
import { ConfigurationProvider, DayEntryProvider, FoodPlanProvider } from '../../providers/providers';

@Component({
  selector: 'page-food-plan-edit',
  templateUrl: 'food-plan-edit.html',
})
export class FoodPlanEditPage {
  foodPlan: FoodPlanModel;
  deleteFoodItems: number[] = [];
  entryTime: moment.Moment = moment();
  foodList: any[] = [];
  foodListSearch: any[] = [];
  user: UserModel;

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private dayEntryProvider: DayEntryProvider,
    private foodPlanProvider: FoodPlanProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.Name : null
    });
  }

  doGetItems(ev: any) {
    // Reset items back to all of the items
    this.foodListSearch = [];
    
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.foodListSearch = this.foodList.filter((item) => {
        return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  doRemove(item: any) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            if (item.FoodPlanFoodId) {
              this.deleteFoodItems.push(item.FoodPlanFoodId);
            }
            this.foodPlan.FoodItems = this.foodPlan.FoodItems.filter((m: any) => m !== item);
          }
        }
      ]
    });
    confirm.present();
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // delete food items, if any
      if (this.deleteFoodItems.length > 0) {
        this.foodPlanProvider.DeleteFoodItems(this.deleteFoodItems);
      }

      // save day entry food items
      this.foodPlanProvider.Save(this.user, this.foodPlan).then((res: FoodPlanModel) => {
        // dismiss
        this.config.dismissLoading();
        this.dismissView(res);
      });
    }
  }

  doSelectFood(item: any) {
    const prompt = this.alertCtrl.create({
      title: 'Log Food',
      message: item.Name,
      inputs: [
        {
          name: 'time',
          type: 'time',
          placeholder: 'Time',
          value: moment(this.entryTime).format('HH:mm')
        },
        {
          name: 'serving',
          type: 'serving',
          placeholder: 'Servings',
          value: '1'
        },
      ],
      buttons: [
        {
          text: 'Cancel'
        },
        {
          text: 'Add',
          handler: data => {
            item.Time = data.time;
            item.Serving = data.serving;
            if (this.foodPlan.FoodItems.find((x: any) => {
              return x === item;
            }) === undefined) {
              this.entryTime = moment(item.Time, 'HH:mm');
              this.foodPlan.FoodItems.push(item);
            }
          }
        }
      ]
    });
    prompt.present();
  }

  formIsValid() {
    if (!this.foodPlan.Name) {
      this.config.showAlert('Error', 'Must enter a Name.');
      return false;
    }
    else if (this.foodPlan.FoodItems.length === 0) {
      this.config.showAlert('Error', 'Must search for and select at least one food item or meal.');
      return false;
    }

    return true;
  }

  ionViewWillLoad() {
    this.foodPlan = this.params.get('foodPlan');
    this.user = this.params.get('user');

    this.loadFoodItems();
  }

  loadFoodItems() {
    this.config.showLoading();

    this.dayEntryProvider.LoadFoodSearch().then((items: any[]) => {
      items.map(x => {
        x.showDetails = false;
        x.icon = 'arrow-dropdown';
      });
      this.foodList = items;

      // load food items for this food plan, if any
      this.foodPlanProvider.LoadFoodItems(this.foodPlan).then((foodPlan: any) => {
        foodPlan.FoodItems.map(x => {
          x.showDetails = false;
          x.icon = 'arrow-dropdown';
        });
        this.foodPlan = foodPlan;
        this.config.dismissLoading();
      });
    });
  }

  toggleDetails(item) {
    if (item.showDetails) {
      item.showDetails = false;
      item.icon = 'arrow-dropdown';
    }
    else {
      item.showDetails = true;
      item.icon = 'arrow-dropup';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/food-plan-edit.ts